/*
 * Conceal service pages — shared runtime.
 * Sustainability: Fig. 01 dead-stock slider (recolours both cell grids, rewrites
 * the count and percentage). Contact: topic chips, conditional field, validation,
 * ?topic= preselect. FAQ: subject rail. No dependencies; re-initialises on
 * theme-editor section loads.
 */
(function () {
  'use strict';

  function clamp(n, lo, hi) {
    return Math.min(hi, Math.max(lo, n));
  }

  /* ---------- Sustainability · Fig. 01 ---------- */
  function paint(cells, sold, printed) {
    for (var i = 0; i < cells.length; i++) {
      cells[i].classList.toggle('cs__cell--sold', i < sold);
      cells[i].classList.toggle('cs__cell--dead', i >= sold && i < printed);
    }
  }

  function initWaste(root) {
    if (root.dataset.csReady === 'true') return;
    var range = root.querySelector('input[type="range"]');
    if (!range) return;
    root.dataset.csReady = 'true';

    var bulk = root.querySelectorAll('[data-cs-cells="bulk"] .cs__cell');
    var mto = root.querySelectorAll('[data-cs-cells="mto"] .cs__cell');
    var outs = root.querySelectorAll('[data-cs-out]');

    function update() {
      var demand = clamp(parseInt(range.value, 10) || 10, 10, 100);
      var dead = 100 - demand;
      paint(bulk, demand, 100);
      paint(mto, demand, demand);
      for (var i = 0; i < outs.length; i++) {
        var key = outs[i].getAttribute('data-cs-out');
        if (key === 'demand') outs[i].textContent = String(demand);
        else if (key === 'dead') outs[i].textContent = String(dead);
        else if (key === 'pct') outs[i].textContent = dead + '%';
      }
    }

    range.addEventListener('input', update);
    range.addEventListener('change', update);
    update();
  }


  /* ---------- Contact ---------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function initContact(root) {
    if (root.dataset.csReady === 'true') return;
    root.dataset.csReady = 'true';

    var refEl = root.querySelector('[data-cs-ref]');
    if (refEl) {
      var d = new Date();
      var p2 = function (n) { return String(n).padStart(2, '0'); };
      refEl.textContent = 'Ref CC-' + String(d.getFullYear()).slice(2) + p2(d.getMonth() + 1) + p2(d.getDate()) + '-' + Math.floor(1000 + Math.random() * 9000);
      refEl.hidden = false;
    }

    var dataEl = root.querySelector('[data-cs-topics]');
    var form = root.querySelector('form#ContactForm');
    if (!dataEl || !form) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var topics = data.topics || [];
    var msgs = data.messages || {};
    var chips = root.querySelectorAll('[data-cs-topic]');
    var caption = root.querySelector('[data-cs-topic-caption]');
    var noteText = root.querySelector('[data-cs-note-text]');
    var routeBtn = root.querySelector('[data-cs-route]');
    var topicInput = root.querySelector('[data-cs-topic-input]');
    var extras = root.querySelectorAll('[data-cs-extra]');
    var current = topics[0] || null;
    form.setAttribute('novalidate', '');

    function extraOf(t) { return t && t.extra && t.extra !== 'none' ? t.extra : ''; }
    function fieldEl(name) { return root.querySelector('[data-cs-field="' + name + '"]'); }
    function inputOf(name) { var f = fieldEl(name); return f ? f.querySelector('input, textarea') : null; }
    function setError(name, msg) {
      var f = fieldEl(name);
      if (!f) return;
      var err = f.querySelector('[data-cs-error]');
      var input = f.querySelector('input, textarea');
      if (msg) {
        f.classList.add('cs__field--error');
        if (err) { err.textContent = msg; err.hidden = false; }
        if (input) input.setAttribute('aria-invalid', 'true');
      } else {
        f.classList.remove('cs__field--error');
        if (err) { err.textContent = ''; err.hidden = true; }
        if (input) input.removeAttribute('aria-invalid');
      }
    }
    function clearErrors() {
      ['name', 'email', 'order_number', 'company', 'publication', 'message'].forEach(function (n) { setError(n, null); });
    }
    function setTopic(id) {
      var t = null;
      for (var i = 0; i < topics.length; i++) if (topics[i].id === id) t = topics[i];
      if (!t) t = topics[0];
      if (!t) return;
      current = t;
      var extra = extraOf(t);
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-cs-topic') === t.id ? 'true' : 'false'); });
      if (caption) caption.textContent = 'No. ' + t.num + ' · ' + t.label;
      if (noteText) noteText.textContent = t.note || '';
      if (routeBtn) {
        if (t.route_url) { routeBtn.hidden = false; routeBtn.href = t.route_url; routeBtn.textContent = t.route_label || t.route_url; }
        else { routeBtn.hidden = true; }
      }
      extras.forEach(function (f) {
        var on = extra && f.getAttribute('data-cs-extra') === extra;
        f.hidden = !on;
        var input = f.querySelector('input');
        var label = f.querySelector('label');
        if (input) { input.disabled = !on; if (on) input.placeholder = t.extra_placeholder || ''; }
        if (label && on && t.extra_label) label.textContent = t.extra_label;
      });
      if (topicInput) topicInput.value = t.label;
      clearErrors();
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () { setTopic(c.getAttribute('data-cs-topic')); });
    });
    var want = null;
    try { want = new URLSearchParams(window.location.search).get('topic'); } catch (e) {}
    setTopic(want ? want.toLowerCase() : (current && current.id));

    root.querySelectorAll('[data-cs-field] input, [data-cs-field] textarea').forEach(function (el) {
      el.addEventListener('input', function () {
        var f = el.closest('[data-cs-field]');
        if (f) setError(f.getAttribute('data-cs-field'), null);
      });
    });

    function value(name) { var i = inputOf(name); return i ? i.value.trim() : ''; }

    form.addEventListener('submit', function (ev) {
      var errors = {};
      var required = msgs.required || 'Required.';
      if (!value('name')) errors.name = required;
      if (!value('message')) errors.message = required;
      var em = value('email');
      if (!em) errors.email = required;
      else if (!EMAIL_RE.test(em)) errors.email = msgs.invalid_email || 'Enter a valid email address.';
      var extra = extraOf(current);
      if (extra && !value(extra)) errors[extra] = extra === 'order_number' ? (msgs.order_required || required) : required;
      var keys = Object.keys(errors);
      if (keys.length) {
        ev.preventDefault();
        clearErrors();
        keys.forEach(function (k) { setError(k, errors[k]); });
        var first = inputOf(keys[0]);
        if (first) first.focus();
        return;
      }
      if (extra === 'order_number') {
        var body = inputOf('message');
        var order = value('order_number');
        var base = body.value.replace(/^Order number:\s[^\n\r]+\s*(?:\r\n|\r|\n){1,2}/, '').trim();
        body.value = order ? 'Order number: ' + order + (base ? '\n\n' + base : '') : base;
      }
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    if (root.dataset.csReady === 'true') return;
    root.dataset.csReady = 'true';
    var buttons = root.querySelectorAll('[data-cs-subject]');
    var groups = root.querySelectorAll('[data-cs-group]');
    if (!buttons.length) return;
    function show(id) {
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cs-subject') === id ? 'true' : 'false'); });
      groups.forEach(function (g) { g.hidden = g.getAttribute('data-cs-group') !== id; });
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        show(b.getAttribute('data-cs-subject'));
        var panel = root.querySelector('.cs__faq-panel');
        if (panel && window.innerWidth < 990) panel.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    });
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-cs-waste]').forEach(initWaste);
    root.querySelectorAll('[data-cs-contact]').forEach(initContact);
    root.querySelectorAll('[data-cs-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
